import { useLocation, useSearchParams } from "react-router-dom"
import "./cancel.css"
import { useEffect, useState } from "react";
import { useMerchantUrlInfoMutation } from "../../Services/serviceApi";

const Cancelled = () => {
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const [orderDetails, setOrderDetails] = useState()
    // const [callMerchantUrlInfo] = useMerchantUrlInfoMutation()


    useEffect(() => {
        let upiObj = {};
        if (searchParams.size) {
            for (const entry of searchParams.entries()) {
                upiObj[entry[0]] = entry[1]
            }
           setOrderDetails((prev)=>({...prev,...upiObj}))
        }
        fetch(`${window.location.origin}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json())
        // callMerchantUrlInfo(upiObj.transactionId)
        .then((res) => {
            if (res?.data == "Failed") {
                // window.open(location.state,"_self")
            } else {
                let obj = Object.entries(res?.data || {}).reduce((acc, [key, value]) => {
                    if (value) acc[key] = value; 
                    return acc;
                  }, {}) 
                  
                setOrderDetails((prev)=>({...prev, ...obj}))
            }
        })
    }, [searchParams])
    
    return <div className="main-box">
                <div className="cancelled-box">
                    <h4 className="title">Transaction Cancelled</h4>
                    <button className="back-button" onClick={()=>{window.open(orderDetails?.failedRedirectionURL,"_self")}}>Back to home</button>
                </div>
            </div>
}

export default Cancelled